



























































/* eslint-disable @typescript-eslint/camelcase */ 
 /* eslint-disable @typescript-eslint/no-explicit-any */ 
  	/* eslint-disable @typescript-eslint/no-unused-vars */ 
	import {audioAulaService }  from '@/servicegerente';
    import Assunto from './Assunto.vue'

	 


	import {Watch, Component, Vue } from 'vue-property-decorator'; 
	  
	@Component({
		components: {  
			Assunto,
        },
	 })
    export default class AudioEdicao extends Vue {

        private model: any = null; 
         
		private titulo: any = null;  
		private tipo: any = null;  
		private restrito: any= null;  
	  
		private urlRetorno: any= '/v2/administracao/audio'; 
		private errors: any = { };

       	created() {
			window.alertProcessando(); 
			audioAulaService.getAudioAula(this.$route.params.id , true) 
			.then(response => {
				this.model = response ;
				window.alertProcessandoHide();
			})
			.catch(error => {
				window.toastErro('Não foi possivel achar a audio aula', error.data);
				window.alertProcessandoHide();
				 
			}); 
		}


		@Watch('model')
		tabelaAtualizada(newVal: any) {
			this.titulo = this.model.titulo; 
			this.restrito = this.model.restrito;  
			this.tipo = this.model.tipo;  
		}

		 
		salvar() {
			window.alertProcessando();
			const dados = {
				titulo :this.titulo,
				restrito :this.restrito,  
				tipo :this.tipo,  
			};   
			 
			audioAulaService.update( this.$route.params.id ,   dados )
			.then(response => {
				window.toastSucesso(response);  
				window.alertProcessandoHide();
				this.$router.push(  this.urlRetorno )
			})
			.catch(error => {  
				window.alertProcessandoHide();
				this.errors = error.data.error; 
				console.log(error);
			});  
		} 
	
 
		
	}

 


